/**
 * 管理后台老师名旁本月总分徽标：批量查分 + 渲染
 * 口径同正式老师页（正式榜五档 + 新锐榜合并）
 */

export function fetchTchScoreMap (http, tchIds) {
  const ids = []
  const seen = {}
  ;(tchIds || []).forEach(function (id) {
    if (id == null || id === '') {
      return
    }
    const n = Number(id)
    if (!n || seen[n]) {
      return
    }
    seen[n] = true
    ids.push(n)
  })
  if (!ids.length) {
    return Promise.resolve({})
  }
  return http.post('/tch/score/batch', {tchIds: ids.join(',')}).then(function (res) {
    const map = {}
    if (!res || res.status !== 'ok' || !res.data) {
      return map
    }
    ;(res.data || []).forEach(function (row) {
      if (!row || row.tchId == null || row.totalScore == null || row.totalScore === '') {
        return
      }
      const num = Number(row.totalScore)
      if (isNaN(num)) {
        return
      }
      map[row.tchId] = num
      map[String(row.tchId)] = num
    })
    return map
  }).catch(function () {
    return {}
  })
}

export function applyTchScoresToRows (vm, rows, idKey, scoreKey, map) {
  idKey = idKey || 'id'
  scoreKey = scoreKey || 'monthRankScore'
  map = map || {}
  if (!rows || !rows.length) {
    return
  }
  rows.forEach(function (row) {
    const id = row[idKey]
    let score = map[id]
    if (score == null) {
      score = map[String(id)]
    }
    vm.$set(row, scoreKey, score == null ? null : score)
  })
}

/**
 * 名字 + 橙色总分徽标（无分不显示徽标）
 * options: { text, score, onClick }
 */
export function renderTchNameWithScore (h, options) {
  options = options || {}
  const text = options.text == null ? '' : options.text
  const nameNode = options.onClick
    ? h('a', {on: {click: options.onClick}}, text)
    : h('span', text)
  let badgeText = null
  if (options.score != null && options.score !== '') {
    const num = Number(options.score)
    if (!isNaN(num)) {
      badgeText = num.toFixed(2)
    }
  }
  if (badgeText == null) {
    return nameNode
  }
  return h('span', {
    style: {
      display: 'inline-flex',
      alignItems: 'flex-start',
      whiteSpace: 'nowrap'
    }
  }, [
    nameNode,
    h('span', {
      style: {
        marginLeft: '4px',
        padding: '0 4px',
        borderRadius: '7px',
        background: '#ff9900',
        color: '#fff',
        fontSize: '10px',
        lineHeight: '14px'
      }
    }, badgeText)
  ])
}



// WEBPACK FOOTER //
// ./src/utils/tchScore.js